import {readCardAndFace,}  from '../../../utils/readCardAndFace'
import { message, Modal } from 'antd';
import {} from '../headerSearch';
let add = '';
/**
 * 海康威视身份证阅读器接口
 * @param {*} type 阅读器类型（xzx：新中新  hs：华视）
 * @param {*} readPort 阅读器接口端口
 * @param {*} mode 读取模式（手动/自动）
 * @param {*} callback 回调的函数
 */
export const readByHkws = (readPort, mode,callback) => {
    if(!readPort || typeof (readPort) == "undefined"){
        readPort = '61126';
    }
    if(mode == 'auto' ){
            add = readCardAndFace(((data) => {
                callback(data)
            }));
            add.open(); //开启连接设备
            add.listen(); //开启监听
            // add.check();
    } else if(mode == 'manual') {
        add = readCardAndFace(((data) => {
            callback(data)
        }));
        add.open(); //开启连接设备
        add.listen(mode); //开启监听
    }
  }


// WEBPACK FOOTER //
// ./components/yxxc/readCard/readByHkws.js